import { IBatch, IProductBatch } from '@core/models/batch.model';

export function formatBatchDate(value?: string | null): string {
    if (!value) return '—';
    try {
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return value;
        return d.toLocaleString();
    } catch {
        return value;
    }
}

export function formatBatchDateOnly(value?: string | null): string {
    if (!value) return '—';
    try {
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return value;
        return d.toLocaleDateString();
    } catch {
        return value;
    }
}

export function formatBatchPrice(value?: number | null): string {
    if (value === undefined || value === null) return '—';
    return `$${Number(value).toFixed(2)}`;
}

export function formatInventoryStatus(status?: string | null): string {
    if (!status) return '—';
    return status
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function serialStatusBadgeClass(status?: string): string {
    switch (status?.toUpperCase()) {
        case 'IN_STOCK':
            return 'bg-green-100 text-green-800';
        case 'SHIPPED':
            return 'bg-slate-200 text-slate-700';
        case 'PICKED_FOR_ORDER':
        case 'IN_TOTE':
            return 'bg-blue-100 text-blue-800';
        case 'RETURNED':
            return 'bg-amber-100 text-amber-900';
        default:
            return 'bg-slate-100 text-slate-700';
    }
}

export function totalBatchQty(batch: IBatch): number {
    return (batch.productBatches ?? []).reduce((sum, pb) => sum + (pb.quantity ?? 0), 0);
}

export function totalSerialCount(batch: IBatch): number {
    return (batch.productBatches ?? []).reduce(
        (sum, pb) => sum + (pb.rxProduct ? (pb.serializedItems?.length ?? 0) : 0),
        0
    );
}

export function productLineCount(batch: IBatch): number {
    return batch.productBatches?.length ?? 0;
}

export function verifiedLineCount(batch: IBatch): number {
    return (batch.productBatches ?? []).filter((pb) => pb.verify).length;
}

export function displayValue(value?: string | number | null): string {
    if (value === undefined || value === null || value === '') return '—';
    return String(value);
}

export function productBatchTitle(pb: IProductBatch): string {
    return pb.productName || `Product #${pb.productId ?? '—'}`;
}
